import React, { useEffect, useRef, useState } from "react";
import { DownChevronIcon, InfoIcon, SendIcon } from "../Svg";
import { Button } from "../Button";
import _ from "lodash";
import cx from "classnames";
import { AIShowcase } from "../../store/models/AIShowcase";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ModalTypes, PredictionStatus } from "../../constants";
import Loader from "../Loader";
import UIState, { selectMobileLayout } from "../../store/UIState";
import { createSelector } from "reselect";
import { ImageInput } from "../form/ImageInput";
import { ShowcaseGallery } from "./ShowcaseGallery";
import DrawingCanvas from "../DrawingCanvas";
import { dataURLtoFile } from "../../utils/blob";
import { TextInput } from "../form/TextInput";
import Tooltip from "../Tooltip";
import { getUrlFromPath } from "../../store/models/Showcases/ShowcaseSketchApi";
import {
  AiOndemandApi, PREDICTION_STARTED, PREDICTION_STOPPED, selectApiKeys,
  selectPredictionId, selectPredictionStatus
} from "../../store/models/AiOndemandApi";
import { extractErrorText, getOndemandErrorMsg, readFileAsDataURL } from "../../utils";
import { selectCurrentUser } from "../../store/models/User";
import { SelectInput } from "../form/SelectInput";
import { useParams } from "react-router";
import { selectOndemandModels, } from '../../store/models/Ai';
import { Checkbox } from "../form/Checkbox";

const LoadingItem = ({ loadingData, elapsedTime }) => {
  const status = !loadingData || loadingData?.msg === 'estimation' ? 'scheduled' : 'processing'
  const bottomWrapper = loadingData?.msg === 'estimation'
    ? <div className={"ResultBox__Loading__BottomWrapper"}>Number of jobs ahead of you: <span
      style={{ color: '#ffffff' }}>{loadingData.rank + 1}</span></div>
    : loadingData?.msg === 'process_starts'
      ? <div className={"ResultBox__Loading__BottomWrapper"}>Generation in progress...</div>
      : <></>

  return (<div className={cx("ResultBox")}>
    <div className={"ResultBox__Loading"}>
      <div className={"ResultBox__Loading__TopWrapper"}>
        {status} | {elapsedTime}s
      </div>

      <div className={"ResultBox__Loading__CenterWrapper"}>
        <Loader color={"green"} />
      </div>

      {bottomWrapper}
    </div>
  </div>)

}

const PromptItem = ({ message }) => {
  const [paramsOpened, setParamsOpened] = useState(false);

  const onToggleParams = () => {
    setParamsOpened(!paramsOpened);
  }

  const hasPrompt = message.prompts && message.prompts.every(p => p.value !== '');

  return (
    <div className={cx("PromptContainerRoot")}>
      <div className={"PromptContainer"}>
        <div className={"PromptContainer__Visible"}>
          <div className="PromptContainer__Left">
            {hasPrompt && <>
              <div className={"PromptContainer__PromptLabel"}>Prompt</div>
              {message.prompts && message.prompts.map(prompt => {
                return prompt.value && <div className={"PromptContainer__PromptValue"}>
                  {prompt.name}: {prompt.value}
                </div>
              })}
            </>}
          </div>
          <div className={"PromptContainer__Right"}>
            {_.map(message.imageUrls, (imageUrl, index) => {
              return (<a key={index} href={imageUrl} target={"_blank"}>
                <img src={imageUrl} />
              </a>)
            })}
          </div>
        </div>
        {!_.isEmpty(message.params) && <div className={"PromptContainer__BottomWrapper"}>
          <div className={`PromptContainer__ParamsButton ${paramsOpened && "open"}`}
            onClick={onToggleParams}>More parameters <DownChevronIcon /></div>
        </div>}
        {paramsOpened &&
          <div className={"PromptContainer__Params"}>
            <pre>{JSON.stringify(message.params, null, 2)}</pre>
          </div>}
      </div>
    </div>)

}

const ResultItem = ({ item }) => {
  return (
    <div className={cx("ResultBox")}>
      <div className={"ResultBox__Image"}>
        <a href={item.image} target={"_blank"}>
          <img src={item.image} alt={"result"} />
        </a>
      </div>
    </div>
  )
}

const ImageInputInstructions = ({ galleryLabel, icon }) => {

  return (<>
    {icon && <div>{icon}</div>}
    <div><span className={"ImageInput__Label--Green"}>Upload {galleryLabel}</span></div>
    <div>or</div>
    <div>drag image here</div>
  </>)
}


const selector = createSelector(
  selectMobileLayout,
  selectApiKeys,
  selectPredictionStatus,
  selectPredictionId,
  selectCurrentUser,
  (isMobile, apiKeys, predictionStatus, predictionId, curUser) => ({
    isMobile,
    apiKeys,
    predictionStatus,
    predictionId,
    curUser
  }
  ))

let intervalId = null;

export const ShowcaseImageToImageItem = ({ model, modelData, className, mName }) => {
  const dispatch = useDispatch();
  const params = useParams();
  const { projectId, id } = params;
  const { templates, services } = useSelector(state => selectOndemandModels(state, projectId));
  const template = templates.find(s => s.id === id);
  const service = services.find(s => s.template_id === template.id);
  let samples = {};
  if (service) {
    let prediction = _.get(Object.values(_.get(service, 'predictions')), '0');
    let instructions = _.get(prediction, 'instructions');
    if (instructions) {
      try {
        let instructionsJson = JSON.parse(instructions);
        samples = _.get(instructionsJson, 'samples')
      } catch (e) {
        console.log('e:', e.message);
      }
    }
  }

  const {
    isMobile,
    apiKeys,
    predictionStatus,
    predictionId,
    curUser
  } = useSelector(state => selector(state));
  const apiKey = _.get(apiKeys, '0.key');
  const [imageUploading, setImageUploading] = useState(false);
  const [loadingData, setLoadingData] = useState(null);
  const [error, setError] = useState(null);
  const [uiError, setUiError] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [currentImageUrls, setCurrentImageUrls] = useState({});
  const [messages, setMessages] = useState([]);
  const chatboxRef = React.createRef();
  const showcaseUrl = model.urls || "https://imagetoimal4c98qyh44-2zd9bpq27fgzq0wcd5d8kdcx0f5e.tec-s10.onthetaedgecloud.com";
  const backgroundRef = useRef(null);
  const layerRef = useRef(null);
  const combineRef = useRef(null);
  const [prompts, setPrompts] = useState({});
  const [rangeInputs, setRangeInputs] = useState({});
  const [choiceInputs, setChoiceInputs] = useState({});
  const [currentImageFiles, setCurrentImageFiles] = useState({});
  const [enableRandomSeed, setEnableRandomSeed] = useState(false);

  useEffect(() => {
    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    }
  }, []);

  useEffect(() => {
    setRangeInputs(_.map(modelData.rangeInputs, p => {
      return {
        name: p.name,
        value: p.default
      }
    }));

    setPrompts(_.map(modelData.prompts, p => {
      return {
        name: p.name,
        value: ""
      }
    }));

    setChoiceInputs(_.map(modelData.choiceInputs, p => {
      return {
        name: p.name,
        value: p.default
      }
    }));

    const ranges = _.map(modelData.rangeInputs, (param) => {
      const range = document.getElementById(param.name);
      range.addEventListener('input', updateGradient);
      setTimeout(() => {
        updateGradient({ target: range })
      }, 100)
      return range;
    });

    return () => {
      ranges.forEach(range => {
        range.removeEventListener('input', updateGradient);
      });
    };
  }, []);

  function updateGradient(e) {
    const range = e.target;
    const value = ((range.value - range.min) / (range.max - range.min)) * 100;
    const color = `linear-gradient(to right, #129978 ${value}%, #3D4463 ${value}%)`;

    // Create a new style element
    const style = document.createElement('style');

    style.textContent = `
    #${range.id}::-moz-range-track {
      background: ${color};
    }
    #${range.id}::-webkit-slider-runnable-track {
      background: ${color};
    }
  `;

    document.head.appendChild(style);
  }


  const onParamChanged = (name, value, needGradientUpdate = false) => {
    const modelParam = modelData.rangeInputs.find(p => p.name === name);
    value = parseFloat(value);

    if (_.isNil(value) || _.isNaN(value)) {
      value = 0;
    } else if (value < modelParam.min) {
      value = modelParam.min
    } else if (value > modelParam.max) {
      value = modelParam.max
    }

    setRangeInputs(rangeInputs.map(param => {
      if (param.name === name) {
        return {
          ...param,
          value: value
        }
      }
      return param;
    }))


    if (needGradientUpdate) {
      setTimeout(() => {
        updateGradient({ target: document.getElementById(name) })
      }, 50)
    }
  }

  const onChoiceChanged = (name, value) => {
    const modelParam = modelData.choiceInputs.find(p => p.name === name);
    setChoiceInputs(choiceInputs.map(param => {
      if (param.name === name) {
        return {
          ...param,
          value: modelParam.isBoolean ? value === 'true' : value
        }
      }
      return param;
    }))
  }

  const onGenerate = async (event) => {
    setError(null)
    setUiError(null)
    event.preventDefault();
    if (mName && mName === 'grounding-dino') {
      if (!prompts[0].value) {
        setUiError('Detection prompt could not be empty.');
        return;
      }
    }

    try {
      setMessages([...messages, {
        type: 'prompt',
        imageUrls: _.values(currentImageUrls),
      }, { type: 'loading' }])
      onScrollToBottom()

      startStopwatch();

      const compositeImages = {};

      if (modelData.drawing_enabled) {
        const backgroundFile = dataURLtoFile(backgroundRef.current.toDataURL(), 'background.png', 'application/octet-stream')
        compositeImages.background = await dispatch(AIShowcase.actions.uploadImage(backgroundFile, showcaseUrl))
        const compositeFile = dataURLtoFile(combineRef.current.toDataURL(), 'composite.png', 'application/octet-stream')
        compositeImages.composite = await dispatch(AIShowcase.actions.uploadImage(compositeFile, showcaseUrl))
        const layerFile = dataURLtoFile(layerRef.current.toDataURL(), 'layer_0.png', 'application/octet-stream')
        compositeImages.layer_0 = await dispatch(AIShowcase.actions.uploadImage(layerFile, showcaseUrl))

        const images = ({ ...currentImageUrls, composite: getUrlFromPath(compositeImages.composite, showcaseUrl) })

        setMessages([...messages, {
          type: 'prompt',
          imageUrls: _.values(images),
          params: _.reduce([...prompts, ...rangeInputs], (obj, param) => {
            obj[param.name] = param.value
            return obj
          }, {})
        }, { type: 'loading' }])
      }

      if (!mName) {
        dispatch(AIShowcase.actions.imageToImagePredict(
          showcaseUrl,
          modelData,
          modelData.drawing_enabled ? compositeImages : currentImageUrls,
          prompts,
          rangeInputs,
          onPredictEvent));
      } else {
        let seed = 0;
        switch (mName) {
          case 'grounding-dino':
            setMessages([...messages, {
              type: 'prompt',
              imageUrls: _.values(currentImageUrls),
              params: _.reduce(rangeInputs, (obj, param) => {
                obj[param.name] = param.value
                return obj
              }, {}),
              prompts: prompts
            }, { type: 'loading' }]);
            break;
          case 'instant-id':
            let seedInput = modelData.switchInputs.find(input => input.label === 'Seed');
            seed = enableRandomSeed
              ? Math.floor(Math.random() * (seedInput.max - seedInput.min + 1)) + seedInput.min
              : seedInput.default;
            let seedObj = { name: 'seed', value: seed };
            setMessages([...messages, {
              type: 'prompt',
              imageUrls: _.values(currentImageUrls),
              params: _.reduce([...rangeInputs, ...choiceInputs, seedObj], (obj, param) => {
                obj[param.name] = param.value
                return obj
              }, {}),
              prompts: prompts
            }, { type: 'loading' }])
            break;
          default:
            break;
        }
        await onHostedGenerate(seed);
      }
    } catch (e) {
      toast.error(e.message)
      if (mName) setMessages((messages) => messages.slice(0, -2))
      console.error(e)
    }
  };

  const onHostedGenerate = async (seed) => {
    dispatch({ type: PREDICTION_STARTED });
    let hasPreSignedUrls = false;
    let imagePresignedUrls = {};
    try {
      for (let name of Object.keys(currentImageFiles)) {
        let url = _.get(currentImageFiles, `${name}.url`);
        if (url) {
          imagePresignedUrls[name] = {};
          imagePresignedUrls[name].filename = url;
        } else {
          let file = _.get(currentImageFiles, `${name}.file`);
          if (!hasPreSignedUrls) {
            await fetchPreSignUrl();
            hasPreSignedUrls = true;
          }
          await dispatch(AiOndemandApi.actions.uploadImageToBucket(file, _.get(imagePresignedUrls, `${name}.presigned_url`)));
        }
      }

      let params = {};
      let prediction;
      switch (modelData.name) {
        case 'background_removal':
          params["image_filename"] = _.get(imagePresignedUrls, 'background.filename');
          prediction = 'background_removal';
          break;
        case "art_style_transfer":
          prediction = 'stylize';
          params["image_filename"] = _.get(imagePresignedUrls, 'image.filename');
          params["style_image_filename"] = _.get(imagePresignedUrls, 'art_style_image.filename');
          break;
        case "image_upscaling":
          prediction = 'upscale';
          params["image_filename"] = _.get(imagePresignedUrls, 'image_to_upscale.filename');
          break;
        case "grounding_dino":
          params = _.reduce([...prompts, ...rangeInputs], (obj, param) => {
            obj[param.name] = param.value
            return obj
          }, {})
          params["input_img"] = _.get(imagePresignedUrls, 'input_img.filename');
          break;
        case "instant_id":
          params = _.reduce([...prompts, ...rangeInputs, ...choiceInputs], (obj, param) => {
            obj[param.name] = param.value
            return obj
          }, {})
          params["seed"] = seed;
          params["face_img"] = _.get(imagePresignedUrls, 'face_img.filename');
          params["pose_img"] = _.get(imagePresignedUrls, 'pose_img.filename');
          break;
        case "esrgan":
          params["input_img"] = _.get(imagePresignedUrls, 'input_img.filename');
          break;
        default:
          break;
      }
      let res;
      switch (mName) {
        case 'esrgan':
        case 'grounding-dino':
        case 'instant-id':
          res = await dispatch(AiOndemandApi.actions.startHostedPredict(params, mName, apiKey));
          break;
        default:
          res = await dispatch(AiOndemandApi.actions.startHostedPredict(params, mName, apiKey, prediction));
          break;
      }
      let outputImageUrl = _.get(res, 'body.infer_requests.0.output.image_url');

      if (outputImageUrl) {
        setLoadingData(null)
        stopInterval()
        setMessages((messages) => [...messages.slice(0, -1), { type: 'result', image: outputImageUrl }])
        onScrollToBottom();
      } else {
        const errMsg = _.get(res, 'body.infer_requests.0.error_message');
        onError(errMsg === 'null' ? null : errMsg);
      }


      async function fetchPreSignUrl() {
        if (!mName || !apiKey) return;
        let prediction = '';
        let model = 'image_to_image';
        switch (modelData.name) {
          case 'background_removal':
            prediction = 'background_removal';
            break;
          case "art_style_transfer":
            prediction = 'stylize';
            break;
          case "image_upscaling":
            prediction = "upscale";
            break;
          case "grounding_dino":
            prediction = "0";
            model = 'grounding_dino';
            break;
          case "instant_id":
            prediction = "generate_image";
            model = "instant_id";
            break;
          case "esrgan":
            prediction = "predict";
            model = 'esrgan';
            break;
          default:
            break;
        }
        if (!prediction) return;
        let res = await dispatch(AiOndemandApi.actions.presignUrl(model, prediction, apiKey));
        switch (modelData.name) {
          case 'background_removal':
            if (!imagePresignedUrls["background"])
              imagePresignedUrls["background"] = _.get(res, "image_filename");
            break;
          case "art_style_transfer":
            if (!imagePresignedUrls["image"])
              imagePresignedUrls["image"] = _.get(res, "image_filename");
            if (!imagePresignedUrls["art_style_image"])
              imagePresignedUrls["art_style_image"] = _.get(res, "style_image_filename");
            break;
          case "image_upscaling":
            if (!imagePresignedUrls["image_to_upscale"])
              imagePresignedUrls["image_to_upscale"] = _.get(res, "image_filename");
            break;
          case "grounding_dino":
            if (!imagePresignedUrls["input_img"])
              imagePresignedUrls["input_img"] = _.get(res, "input_img");
            break;
          case "instant_id":
            if (!imagePresignedUrls["face_img"])
              imagePresignedUrls["face_img"] = _.get(res, "face_img");
            if (!imagePresignedUrls["pose_img"] && currentImageFiles['pose_img'])
              imagePresignedUrls["pose_img"] = _.get(res, "pose_img");
            break;
          case "esrgan":
            if (!imagePresignedUrls["input_img"])
              imagePresignedUrls["input_img"] = _.get(res, "input_img");
            break;
          default:
            break;
        }
      }
    } catch (e) {
      dispatch({ type: PREDICTION_STOPPED });
      onError(getOndemandErrorMsg(e.message, curUser));
    }
  }

  const onSelectGalleryImage = async (itemIndex, name) => {
    const gallery = _.find(modelData.galleries, gallery => gallery.name === name)
    // const imageUrl = gallery.isLocal ? gallery.paths[itemIndex] : `${showcaseUrl}${gallery.paths[itemIndex]}`
    const imageUrl = _.get(samples, `${gallery.name}`)
      ? _.get(samples, `${gallery.name}.${itemIndex}`)
      : (gallery.isLocal
        ? gallery.paths[itemIndex]
        : `${showcaseUrl}${gallery.paths[itemIndex]}`);
    setCurrentImageUrls({
      ...currentImageUrls,
      [name]: imageUrl
    })
    if (!mName) return;
    setCurrentImageFiles({
      ...currentImageFiles, [name]: { url: imageUrl }
    })
  }



  const onImageSelected = async (file, name) => {
    if (!file) return;

    try {
      setImageUploading(true)
      let imageUrl;
      if (!mName) {
        const imagePath = await dispatch(AIShowcase.actions.uploadImage(file, showcaseUrl))
        imageUrl = getUrlFromPath(imagePath, showcaseUrl)
      } else {
        imageUrl = await readFileAsDataURL(file);
        setCurrentImageFiles({
          ...currentImageFiles, [name]: { file: file }
        })
      }

      setCurrentImageUrls({
        ...currentImageUrls, [name]: imageUrl
      })
      setImageUploading(false)
    } catch (e) {
      console.log('error:', e.message);
      setImageUploading(false)
      toast.error("Failed to upload image")
    }
  }

  const onPredictEvent = (event) => {
    switch (event.msg) {
      case 'estimation':
        setLoadingData(event)
        break;
      case 'process_starts':
        setLoadingData(loadingData => ({ ...loadingData, msg: 'process_starts' }))
        break;
      case 'process_completed':
        try {
          if (event.success) {
            setLoadingData(null)
            stopInterval()
            setMessages((messages) => [...messages.slice(0, -1), { type: 'result', image: event.output.data[0].url }])
            onScrollToBottom()
          } else {
            onError("Failed to generate")
          }
        } catch (e) {
          onError("Failed to generate: " + e.message)
        }
        break;
      case 'error':
      case 'unexpected_error':
        onError(event.error)
        break;
    }
  }

  const onError = (error) => {
    setLoadingData(null)
    setMessages((messages) => messages.slice(0, -2))
    stopInterval()
    setError(error ?? "Failed to generate. Try again later")
    error = extractErrorText(error)
    toast.error(error ?? "Failed to generate. Try again later")
  }

  const startStopwatch = () => {

    if (intervalId) {
      stopInterval()
    }

    const startTime = new Date().getTime()

    intervalId = setInterval(() => {
      const currentTime = new Date().getTime()
      setElapsedTime(((currentTime - startTime) / 1000).toFixed(0))
    }, 1000)

  }

  const stopInterval = () => {
    clearInterval(intervalId)
    intervalId = null
    setElapsedTime(0)
  }

  const onStopGenerating = (event) => {
    event.preventDefault();

    dispatch(UIState.actions.showModal(ModalTypes.CONFIRM, {
      title: "Stop generating",
      message: "Are you sure you want to stop the ongoing generation?",
      onConfirm: onConfirmStopGenerating,
      confirmLabel: "Yes",
      cancelLabel: "No",
      size: 's'
    }))
  }

  const onConfirmStopGenerating = () => {
    stopInterval()
    setLoadingData(null)
    setMessages((messages) => messages.slice(0, -2))
    if (mName) {
      dispatch(AiOndemandApi.actions.stopHostedPredict(predictionId, apiKey));
    } else {
      dispatch(AIShowcase.actions.stopGeneration())
    }
  }

  const onClear = () => {
    setPrompts(_.map(modelData.prompts, p => {
      return {
        name: p.name,
        value: ""
      }
    }));

    setRangeInputs(_.map(modelData.rangeInputs, p => {
      return {
        name: p.name,
        value: p.default
      }
    }));

    setChoiceInputs(_.map(modelData.choiceInputs, p => {
      return {
        name: p.name,
        value: p.default
      }
    }));

    _.forEach(modelData.rangeInputs, (param) => {
      const range = document.getElementById(param.name);
      setTimeout(() => {
        updateGradient({ target: range })
      }, 100)
    });

    setCurrentImageUrls({})
  }

  const onRemoveImage = (name) => {
    setCurrentImageUrls(_.omit(currentImageUrls, name))
  }

  const onScrollToBottom = () => {
    if (!isMobile) {
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
        if (!_.isNil(chatboxRef) && !_.isNil(chatboxRef.current)) {
          chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
        }
      }, 200)
    }
  }

  const onPromptChanged = (value, name) => {
    setPrompts(prompts.map(param => {
      if (param.name === name) {
        return {
          ...param,
          value: value
        }
      }
      return param;
    }))
  }

  return (
    <div className={cx("ShowcaseImageToImageItem", className)}>
      <div className="ShowcaseImageToImageItem__container">
        <div className={"ShowcaseImageToImageItem__LeftSide"}>

          <div className={"SidePanel"}>

            <form className="SidePanel__form">

              {modelData.instructions && <div className={"SidePanel__Instructions"}>{modelData.instructions}</div>}

              <div className={"SidePanel__ImageInputs"}>
                {_.map(modelData.galleries, (gallery, index) => {
                  const currentImageUrl = currentImageUrls[gallery.name];
                  let galleryImages = _.get(samples, `${gallery.name}`)
                    ? _.get(samples, `${gallery.name}`)
                    : (gallery.isLocal
                      ? gallery.paths
                      : _.map(gallery.paths, (path) => `${showcaseUrl}${path}`))

                  return (<>
                    {(modelData.drawing_enabled && currentImageUrl)
                      ? <div className={"DrawingCanvasWrapper"} key={`div-${index}`}>
                        <DrawingCanvas key={`canvas-${index}`}
                          imageUrl={currentImageUrl}
                          backgroundRef={backgroundRef}
                          layerRef={layerRef}
                          combineRef={combineRef} />
                      </div>
                      : <ImageInput key={`image-input-${index}`}
                        value={currentImageUrl}
                        name={gallery.name}
                        label={gallery.label}
                        onChange={onImageSelected}
                        onRemove={onRemoveImage}
                        formats={"image/jpeg, image/jpg, image/png"}
                        instructions={<ImageInputInstructions galleryLabel={gallery.label} />}>
                        <div className={"ImageInput__LeftBadge"}>{gallery.label}</div>
                      </ImageInput>
                    }
                    {(isMobile || mName) &&
                      <ShowcaseGallery
                        key={`gallery-${index}`}
                        images={galleryImages}
                        title={gallery.galleryLabel}
                        onClick={onSelectGalleryImage}
                        name={gallery.name} />
                    }
                  </>)
                })}

              </div>

              <div className={"SidePanel__Examples"}>
                {!isMobile && !mName && _.map(modelData.galleries, (gallery, index) => {

                let galleryImages = _.get(samples, `${gallery.name}`)
                    ? _.get(samples, `${gallery.name}`)
                    : (gallery.isLocal
                      ? gallery.paths
                      : _.map(gallery.paths, (path) => `${showcaseUrl}${path}`))

                  return (<ShowcaseGallery key={`gallery-${index}`}
                    images={galleryImages}
                    title={gallery.galleryLabel}
                    onClick={onSelectGalleryImage}
                    name={gallery.name} />)
                })}
              </div>

              {(!_.isEmpty(modelData.prompts) || !_.isEmpty(modelData.rangeInputs)) &&
                <div className={"SidePanel__Prompts"}>
                  {_.map(modelData.prompts, (prompt) => {
                    return (<TextInput key={prompt.name}
                      name={prompt.name}
                      placeholder={prompt.label}
                      value={_.find(prompts, promptValues => promptValues.name === prompt.name)?.value}
                      onChange={(e) => onPromptChanged(e.target.value, prompt.name)}
                    />)
                  })}

                  {_.map(modelData.choiceInputs, (param, index) => {
                    return (
                      <div key={param.name} className="ShowcaseSettingsPanel__field">
                        <div className={"ShowcaseSettingsPanel__field--top"}>
                          <Tooltip longText={true}
                            tooltip={param.desc}>
                            <div className={"label-wrapper"}>
                              <label htmlFor={param.name}>{param.label}</label>
                              <InfoIcon />
                            </div>
                          </Tooltip>
                          <SelectInput className={`SidePanel__Select ${param.long ? "large" : ""}`}
                            options={Object.keys(param.choices).map(k => ({ label: param.choices[k + ''], value: k + '' }))}
                            value={{ label: param.choices[choiceInputs?.[index]?.value], value: choiceInputs?.[index]?.value }}
                            onChange={(e) => onChoiceChanged(param.name, e.value)}
                            styles={customStyles}
                          />
                        </div>
                      </div>
                    )
                  })}

                  {_.map(modelData.switchInputs, (param, index) => {
                    return (
                      <div key={param.name} className="ShowcaseSettingsPanel__field">
                        <div className={"ShowcaseSettingsPanel__field--top"}>
                          <Tooltip longText={true}
                            tooltip={param.desc}>
                            <div className={"label-wrapper"}>
                              <label htmlFor={param.name}>{param.label}</label>
                              <InfoIcon />
                            </div>
                          </Tooltip>
                          <Checkbox
                            label={param.checkboxLabel}
                            checked={enableRandomSeed}
                            onChange={(e) => setEnableRandomSeed(e.target.checked)}
                          />
                        </div>
                      </div>
                    )
                  })}

                  {_.map(modelData.rangeInputs, (param, index) => {
                    return (
                      <div key={param.name} className="ShowcaseSettingsPanel__field">
                        <div className={"ShowcaseSettingsPanel__field--top"}>
                          <Tooltip longText={true}
                            tooltip={param.desc}>
                            <div className={"label-wrapper"}>
                              <label htmlFor={param.name}>{param.label}</label>
                              <InfoIcon />
                            </div>
                          </Tooltip>
                          <TextInput step={param.step} max={param.max} min={param.min}
                            className={param.className ? param.className : (param.long ? "large" : "")}
                            type={"number"}
                            value={rangeInputs?.[index]?.value} name={param.name}
                            onChange={(e) => onParamChanged(param.name, e.target.value, true)} />
                        </div>
                        <input type="range" id={param.name} step={param.step} max={param.max} min={param.min}
                          value={rangeInputs?.[index]?.value}
                          onChange={(e) => onParamChanged(param.name, e.target.value)} />
                      </div>
                    )
                  })}

                </div>}

              {uiError && <div className={"SidePanel__Error"}>
                {uiError}
              </div>}
              <div className={"SidePanel__ActionButtons"}>
                <Button
                  title={"Clear"}
                  color={"grey"}
                  className="SidePanel__ActionButtons__Button SidePanel__ActionButtons__Button"
                  disabled={_.size(currentImageUrls) === 0}
                  onClick={onClear}
                  role={"button"}
                />

                {(loadingData || predictionStatus === PredictionStatus.IN_PROGRESS)
                  ? <Button
                    title={"Stop generating"}
                    onClick={onStopGenerating}
                    className="SidePanel__ActionButtons__Button--Primary"
                    color={"red"}
                  />
                  : <Button
                    title={"Generate"}
                    onClick={onGenerate}
                    loading={imageUploading}
                    icon={imageUploading ? null : <SendIcon />}
                    className="SidePanel__ActionButtons__Button SidePanel__ActionButtons__Button--Primary"
                    color={"green"}
                    disabled={!_.isNil(loadingData)
                      || predictionStatus === PredictionStatus.STARTED
                      || (_.size(currentImageUrls) < _.size(modelData.galleries) && mName !== 'instant-id')
                      || (mName && mName === 'instant-id' && _.isNil(_.get(currentImageUrls, 'face_img')))
                    } />}
              </div>

            </form>

          </div>
        </div>

        <div className={cx("ShowcaseImageToImageItem__RightSide")}>
          {error && <div className={"ErrorMessage"}>{error}</div>}

          <div className={"MessagesWrapper"} ref={chatboxRef}>
            {!_.isEmpty(messages) && messages.map((item, index) => {
              switch (item.type) {
                case 'prompt':
                  return (<PromptItem key={index} message={item} />)
                case 'loading':
                  return (<LoadingItem key={index} loadingData={loadingData} elapsedTime={elapsedTime} />)
                case 'result':
                  return (<ResultItem key={index} item={item} />)
              }
            })}
          </div>

        </div>
      </div>

    </div >
  );
}
const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#131722',
    borderColor: state.isFocused ? '#18C99D' : '#3D4463',
    borderRadius: '6px',
    color: '#8A8FB5',
    outline: 'none',
    boxShadow: 'none',
    ':hover': {
      borderColor: '#18C99D', // Add your hover styles here
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? 'rgba(24, 201, 157, 0.1)' : '#131722',
    color: state.isFocused ? '#18C99D' : state.isSelected ? '#18C99D' : '#8A8FB5',
    fontFamily: 'Gilroy',
    paddingLeft: '10px',
    fontWeight: '500',
    fontSize: '14px',
    paddingTop: '11.5px',
    paddingBottom: '11.5px',
    position: 'relative',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    marginLeft: '7px',
    borderColor: state.isFocused ? '#18C99D' : '#3D4463',
    color: '#8A8FB5',
    fontFamily: 'Gilroy',
    fontWeight: '500',
    fontSize: '14px',
    height: '15px',
    outline: 'none',
  }),
  indicatorsContainer: (provided, { isDisabled }) => ({
    ...provided,
    display: isDisabled ? 'none' : 'flex',
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: '#8A8FB5',
    marginRight: '8px',
    ':hover': {
      color: '#8A8FB5', // Add your hover styles here
    },
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: '#131722',
    border: '1px solid #3D4463',
    borderRadius: '6px',
    scrollbarColor: '#3D4463',
    maxHeight: '300px',
  }),
  menuList: (provided, state) => ({
    ...provided,
    maxHeight: '300px',
  }),
}